import React from "react";
import ReactBeforeSliderComponent from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";
import clsx from "clsx";
import NobIcon from "icons/nob.svg";

const BeforeAfterImage = ({ title, selectionImages, images, mainImage, sliderPercentPosition, sliderWrapperClassName, fill }: any) => {
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  const basePosition = sliderPercentPosition ?? 50;
  const [position, setPosition] = React.useState<number>(basePosition);
  const animFrameRef = React.useRef<number | null>(null);
  const hasInteractedRef = React.useRef<boolean>(false);
  const lastTriggerRef = React.useRef<number>(0);

  React.useEffect(() => {
    return () => {
      if (animFrameRef.current !== null) cancelAnimationFrame(animFrameRef.current);
    };
  }, []);

  const runAnimation = (from: number, to: number, duration: number, onDone?: () => void) => {
    if (animFrameRef.current !== null) cancelAnimationFrame(animFrameRef.current);
    const start = performance.now();
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 0.5 - 0.5 * Math.cos(Math.PI * t);
      setPosition(from + (to - from) * eased);
      if (t < 1) {
        animFrameRef.current = requestAnimationFrame(tick);
      } else {
        animFrameRef.current = null;
        if (onDone) onDone();
      }
    };
    animFrameRef.current = requestAnimationFrame(tick);
  };

  const handleMouseEnter = () => {
    if (hasInteractedRef.current) return;
    if (animFrameRef.current !== null) return;
    if (performance.now() - lastTriggerRef.current < 1500) return;
    lastTriggerRef.current = performance.now();
    const peak = Math.min(100, basePosition + 18);
    runAnimation(basePosition, peak, 380, () => {
      runAnimation(peak, basePosition, 420);
    });
  };

  const handleInteract = () => {
    hasInteractedRef.current = true;
    if (animFrameRef.current !== null) {
      cancelAnimationFrame(animFrameRef.current);
      animFrameRef.current = null;
    }
  };

  return (
    <div className={clsx("flex flex-col w-full", fill && "h-full")}>
      <div className={clsx("relative", fill && "ba-fill h-full w-full", sliderWrapperClassName)} onMouseEnter={handleMouseEnter} onMouseDown={handleInteract} onTouchStart={handleInteract}>
        <ReactBeforeSliderComponent
          firstImage={{ imageUrl: images[selectedImageIndex] }}
          secondImage={{ imageUrl: mainImage }}
          currentPercentPosition={position}
          delimiterIconStyles={{
            width: "44px",
            height: "44px",
            backgroundImage: `url(${NobIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "26px 26px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        />
      </div>

      {selectionImages?.length > 0 && (
        <div className="flex-center w-full mt-4">
          <div className="flex flex-col gap-2.5 p-3 bg-green rounded-xl">
            <span className="text-headline-satoshi">{title}</span>
            <div className="flex items-center gap-1.5">
              {selectionImages.map((image: any, index: number) => (
                <div
                  className={clsx("p-[3px] rounded-md border-[2px]", selectedImageIndex === index ? "" : "cursor-pointer border-transparent")}
                  key={"BeforeAfterImageSelect_" + index}
                  onClick={() => setSelectedImageIndex(index)}
                >
                  <img src={image} className="flex-shrink-0 aspect-square w-[60px] object-cover rounded-[3px]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BeforeAfterImage;
